// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB0bPbT1zlwdXne74V9_Q8N7XcL-mm8oJg",
  authDomain: "index-fund-sahi-hai.firebaseapp.com",
  projectId: "index-fund-sahi-hai",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
